import React, {Component} from 'react';
import PropTypes from 'prop-types';

import FormInputField from './FormInputField';

class FormInput extends Component {

	// render input type
	renderInput(type) {
		if (type === 'checkbox') {
			return (
				<FormInputField
					type={this.props.type}
                    name={this.props.name}
					options={this.props.options}
                    labelName={this.props.labelName}
                    inputStyle={this.props.fieldStyle}
                    disabled={this.props.disabled}
					checked={this.props.checked}
					value={this.props.value}
				/>
			);
		} else {
			return (
                <div style={this.props.formInputStyle}>
					<FormInputField
						type={this.props.type}
						name={this.props.name}
                        inputStyle={this.props.fieldStyle}
						value={this.props.value}
						options={this.props.options}
						checked={this.props.checked}
                        placeholder={this.props.placeholder}
						min={this.props.min}
						max={this.props.max}
                        step={this.props.step}
                        readonly={this.props.readonly}
						disabled={this.props.disabled}
						id={this.props.id} />
				</div>
			);
		}
	}

    /**
	 * render
     * @returns {XML}
     */
	render() {
		// TODO check this select
		if(this.props.type === 'select') {
			return (
                <div className={this.props.divClass} style={this.props.formInputStyle}>
					<FormInputField
						type={this.props.type}
                        inputStyle={this.props.fieldStyle}
						name={this.props.name}
						value={this.props.value}
						options={this.props.options}
						disabled={this.props.disabled}
						id={this.props.id} />
					<label className='form-input' style={this.props.labelStyle ? this.props.labelStyle : {top: '-25px', left: '10px'}}>
						{this.props.label}
					</label>
				</div>
			);
		}

		else if (this.props.label || this.props.subLabel) {
			if (this.props.labelPosition === 'inline') {
				return (
					<div className={this.props.divClass} style={this.props.formInputStyle}>
						<label className='form-input'>
							<span
								className={this.props.labelClass}
								style={this.props.labelStyle}>
								{this.props.label ? this.props.label : null}
							</span>
							<FormInputField
								type={this.props.type}
                                inputStyle={this.props.fieldStyle}
                                labelName={this.props.labelName}
								name={this.props.name}
								value={this.props.value}
								options={this.props.options}
								checked={this.props.checked}
                                placeholder={this.props.placeholder}
                                step={this.props.step}
								min={this.props.min}
								max={this.props.max}
								disabled={this.props.disabled}
                                readonly={this.props.readonly}
								id={this.props.id} />
							<span
								className={this.props.labelClass}
								style={this.props.subLabelStyle}>
								{this.props.subLabel ? this.props.subLabel : null}
							</span>
						</label>
                            {this.props.children}
					</div>
				);
			} else {
                return (
                    <div className={this.props.divClass} style={this.props.formInputStyle}>
							<label style={{width: '100%'}} className='form-input'>
								<div
									className={this.props.labelClass}
									style={this.props.labelStyle ? this.props.labelStyle : {paddingBottom: '8px', fontWeight: 'bold'}}>
									{this.props.label ? this.props.label : null}
								</div>
								<FormInputField
									type={this.props.type}
									inputStyle={this.props.fieldStyle}
                                    labelName={this.props.labelName}
									name={this.props.name}
									value={this.props.value}
									options={this.props.options}
									checked={this.props.checked}
                                    placeholder={this.props.placeholder}
									disabled={this.props.disabled}
									id={this.props.id}
                                    step={this.props.step}
                                    readonly={this.props.readonly}
									min={this.props.min}
									max={this.props.max} />
								<div
									className={`${this.props.labelClass} center-align`}
									style={this.props.subLabelStyle}>
									{this.props.subLabel ? this.props.subLabel : null}
								</div>
							</label>
                                {this.props.children}
						</div>
                );
			}
		} else {
            return (
            	<div className={this.props.divClass}>
                    {this.renderInput(this.props.type)}
				</div>
        	);
		}
	}

}

/**
 * Prop types
 * @type {{tempDetails: *}}
 */
FormInput.propTypes = {
    switchButton: PropTypes.object,
    position: 		  PropTypes.string,
    maxLength:	   PropTypes.number,
    checked: 		   PropTypes.oneOfType([
                         PropTypes.string,
                         PropTypes.bool,
    ]),
    options: PropTypes.oneOfType([
                                         PropTypes.array,
                                         PropTypes.object,
    ]),
    type: 			   PropTypes.string,
	inputStyle: PropTypes.string,
    value: 		   PropTypes.oneOfType([
                                     PropTypes.string,
                                     PropTypes.number,
    ]),
	disabled: 		   PropTypes.bool,
    label: 			     PropTypes.string,
    subLabel: 		   PropTypes.string,
    labelName: 		  PropTypes.string,
    labelPosition: PropTypes.string,
    labelClass: 	  PropTypes.string,
	labelStyle: 	  PropTypes.object,
	subLabelStyle: PropTypes.object,
	name: 		       PropTypes.string,
    id: 		         PropTypes.string,
	fieldStyle: 	  PropTypes.object,
    min: 			       PropTypes.number,
    max: 			       PropTypes.number,
    step:          PropTypes.number,
};

export default FormInput;



// WEBPACK FOOTER //
// ./src/components/forms/FormInput.js